import orderStatus, { OrderStatus } from 'constants/orderStatus';
import { isSlotToday } from './is-slot-today';

export const isOrderFailedPayment = (
  status: OrderStatus | string | undefined,
  slotStartDateTime: string | undefined,
): boolean => status === orderStatus.PAYMENT_FAILED && isSlotToday(slotStartDateTime);
